











































import Vue from 'vue'
import { ValuationPreview } from '@/interfaces/valuation/ValuationRecord'
import debounce from 'lodash.debounce'

export default Vue.extend({
  created() {
    this.debouncedQueryPreviews = debounce(this.queryPreviews, 700)
  },
  data() {
    return {
      isVisible: false,
      searchText: '',
    }
  },
  computed: {
    previews(): ValuationPreview[] {
      return this.$store.getters['valuationSearch/previews']
    },
    hasSearchText(): boolean {
      return Boolean(this.searchText.length)
    },
    hasMatches(): boolean {
      return Boolean(this.previews.length)
    },
    matchesCount(): number {
      return this.previews.length
    },
    isLoading(): boolean {
      return this.$store.getters['app/loading']
    },
    matchTranslation(): string {
      switch (this.matchesCount) {
        case 1:
          return 'výsledek'
          break
        case 2:
        case 3:
        case 4:
          return 'výsledky'
          break
        default:
          return 'výsledků'
          break
      }
    },
  },
  methods: {
    debouncedQueryPreviews() {
      debounce(this.queryPreviews, 500)
    },
    queryPreviews() {
      if (this.searchText) {
        this.$store.dispatch('valuationSearch/fetchPreviews', this.searchText)
      }
    },
  },
  watch: {
    isVisible(val: boolean) {
      if (val) {
        const searchInput: any = this.$refs.searchInput
        this.$nextTick(() => {
          if (searchInput && searchInput.hasOwnProperty('focus')) {
            searchInput.focus()
          }
        })
      }
    },
    searchText(val: string) {
      if (val) {
        this.debouncedQueryPreviews()
      } else {
        this.$store.commit('valuationSearch/setPreviews', [])
      }
    },
  },
})
